import React from 'react';
import { getClass } from '../../../utils/component-helpers';
import Icon from '../../ui/icon';

import './strategy-creation.scss';

const ObjectiveOption = props => {
  const { name, selectedOption, onClick } = props;
  const isSelected = name === selectedOption;

  const objectiveConfig = {
    default: {
      name: 'All SKUs',
      iconName: 'docs',
      description: 'I want to target all SKUs.',
    },
    sale: {
      name: 'Sale',
      iconName: 'salesTag',
      description: 'I am running a sale on my products.',
    },
    product_launch: {
      name: 'Product Launch',
      iconName: 'newProducts',
      description: 'I am preparing for a product to launch and want to create buzz.',
    },
    product_category: {
      name: 'Product Collections',
      iconName: 'collections',
      description: 'I want to select specific product collections to add to my campaign.',
    },
    hero_products: {
      name: 'Hero Products',
      iconName: 'heroProducts',
      description: 'I want to promote my hero products that are consistently top performers.',
    },
    keywords: {
      name: 'Keywords',
      iconName: 'keywords',
      description: 'I want to target specific keywords.',
    },
  };

  if (!objectiveConfig[name]) return null;

  const config = objectiveConfig[name];

  return (
    <div
      className={getClass('objective-option', { selected: isSelected })}
      onClick={() => onClick(name)}
    >
      {isSelected && (
        <div className="selected-icon">
          <Icon iconName="circleCheck" size={26} />
        </div>
      )}
      <div className="objective-icon">
        <Icon iconName={config.iconName} size={82} />
      </div>

      <div className="objective-text">
        <div className="objective-label">{config.name}</div>
        <div className="objective-description">{config.description}</div>
      </div>
    </div>
  );
};

export default ObjectiveOption;
